import { initContract } from "@ts-rest/core";
import { z } from "zod";
import {
  SavePurchaserDiscount,
  UpdateSavedDeliveryInfo,
} from "../schemas/index.js";

const c = initContract();

export const nominatedPurchaserContract = c.router({
  savePurchaserDiscount: {
    method: "POST",
    path: "/trade-sales/nominated-purchaser/discount",
    responses: {
      [200]: z.object({ nominatedPurchaserId: z.string() }),
    },
    body: SavePurchaserDiscount,
    summary: "Save discount number for nominated purchaser.",
  },
  updateSavedDeliveryInfo: {
    method: "POST",
    path: "/trade-sales/customer/delivery-info/:nominatedPurchaserId",
    pathParams: z.object({
      nominatedPurchaserId: z.string(),
    }),
    body: UpdateSavedDeliveryInfo,
    responses: {
      [200]: z.object({ status: z.literal("success") }),
    },
    summary:
      "Creates or updates a nominated purchasers saved delivery information - currently this will only work for a single address",
  },
});
